<template>
  <div class="send-login-code-view">
    <div class="description" v-if="!success" v-text="$t('send-login-code-description')"></div>



    <ion-item v-if="!success">
      <div class="input-line">
        <div class="validation-errors" v-if="errors && errors.email">
          <span class="validation-error" v-for="error of errors.email" v-text="error" :key="error"></span>
        </div>

        <ion-input :label="$t('send-login-code-email-label')" label-placement="stacked" name="email" type="text"
          :placeholder="$t('send-login-code-email-placeholder')" v-model="email" :class="{
            'has-errors': errors && (errors.email || errors.global),
          }" />

      </div>
    </ion-item>

    <ion-item lines="none" v-if="!success">
      <div class="input-line">
        <div class="validation-errors" v-if="errors && errors.acceptedPrivacy">
          <span class="validation-error" v-for="error of errors.acceptedPrivacy" v-text="error" :key="error"></span>
        </div>
        <ion-checkbox slot="start" v-model="acceptedPrivacy" name="acceptedPrivacy" labelPlacement="end"
          v-html="$t('send-login-code-accept-privacy-label')"></ion-checkbox>

      </div>
    </ion-item>
    <div class="success-message" v-if="success">
      <OidoIcon name="mail-sent"></OidoIcon>
      <div v-text="$t('send-login-code-success-message')"></div>
    </div>

    <oido-button class="get-code-button" @click="sendLoginCode" :show-spinner="sending" :primary="true"
      buttonStyle="solid" :label="success ? $t('send-login-again-button-label') : $t('send-login-button-label')"
      icon="person-circle"></oido-button>



  </div>
</template>

<script setup>
import customerService from '../composables/customerService'
import OidoButton from '../components/OidoButton.vue'
import Validator from "validatorjs";
import { IonInput, IonItem, IonCheckbox } from '@ionic/vue';
import OidoIcon from '../components/OidoIcon.vue';
</script>

<script>
export default {
  props: [],
  data() {
    return {
      sending: false,
      acceptedPrivacy: false,
      email: null,
      errors: null,
      success: false
    }
  },
  methods: {
    async sendLoginCode() {
      this.errors = {}
      this.sending = true

      let rules = {
        acceptedPrivacy: "boolean|accepted",
        email: "required|email",
      }
      let data = {
        email: this.email,
        acceptedPrivacy: this.acceptedPrivacy
      }

      let validation = new Validator(data, rules);
      validation.setAttributeNames({
        email: this.$t("send-login-code-email-label"),
        acceptedPrivacy: this.$t("send-login-code-accepted-privacy-error-field-name")
      });

      if (validation.fails()) {
        this.errors = validation.errors.errors
        this.sending = false
        this.success = false
        return
      }

      let result = await customerService.sendLoginCode(this.company.id, this.email)

      if (!result || result.errors) {
        this.errors = result ? result.errors : {}
      }
      this.success = !this.errors || Object.keys(this.errors).length == 0

      this.sending = false
      return result

    },

  },
}
</script>
<style scoped>
.send-login-code-view {
  font-size: 0.8rem;
  width: 300px;
}

.description {
  padding: 1rem;
  padding-bottom: 0.5rem;

}

ion-input {
  font-size: 0.8rem;
}

ion-item .input-line {
  width: 100%;
}

ion-checkbox {
  font-size: 0.8rem;
  margin-bottom: 0.4rem;
}

ion-checkbox::part(label) {
  text-wrap: wrap;
}


.success-message {
  padding: 1rem 0.5rem;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  /* color: var(--ion-color-success); */  
  display: flex;
  align-items: center;
}
.success-message .oido-icon{
  width: 8rem;
  margin-right: 1.2rem;
}
</style>
<style></style>
